import { ConciergeGeneralSettingsParser } from "@redotech/redo-concierge-settings-common/general";
import * as z from "zod";

export const getConciergeGeneralSettings = {
  name: "getConciergeGeneralSettings" as const,
  input: z.null(),
  output: z.object({ settings: ConciergeGeneralSettingsParser.optional() }),
};
